import { IApplicationState } from '../../types/redux';
import { selectProductById } from '../analytics';
import { selectQueryString } from '../page';

export const selectTrackingPromoDetailsById = (id: string) => (state: IApplicationState) => {
  const product = selectProductById(id)(state);
  const queryString = selectQueryString(state);

  return {
    product,
    sc: queryString,
  };
};
